import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import { FormElementConfig } from '../../models/FormElementConfig';
import { GdlService } from '../../services/gdl-service/gdl.service';

@Component({
  selector: 'wpro-form-select',
  templateUrl: './form-select.component.html',
  standalone: false,
})

export class FormSelectComponent {
  @Output() selectedValue = new EventEmitter<any>();
  @Input() config: FormElementConfig;
  @Input() isLoading?: boolean;
  @Input() dropdownControl?: UntypedFormControl;

  constructor(private gdlService: GdlService) { }

  onSelect(event: any): void {
    const phoneType = event;

    this.selectedValue.emit(event);
    this.publishPhoneOrMobileClickGDLTag(phoneType);
  }

  publishPhoneOrMobileClickGDLTag(phoneType: string): void {
    if (phoneType === 'PHONE') {
      this.gdlService.triggerGdlLogEvent('interaction', 'click', { name: 'wpro-loginsecurity-primaryphonenumber' });
    } else {
      this.gdlService.triggerGdlLogEvent('interaction', 'click', { name: 'wpro-loginsecurity-secondphonenumber' });
    }
  }
}
